import React from "react";

//MUI
import { Box, Dialog, DialogContent } from "@mui/material";
import { styled } from "@mui/material/styles";

//components
import DialogBoxTitle from "./DialogBoxTitle";

const BootstrapDialog = styled(Dialog)(() => ({
  "& .MuiDialog-paper": {
    padding: "1em",
    overflow: "inherit",
  },
})) as typeof Dialog;

type Props = {
  isModalOpen: boolean;
  modalTitle: string;
  handleModalClose: () => void;
  children: React.ReactNode;
};

const DialogBox = ({
  isModalOpen,
  modalTitle,
  handleModalClose,
  children,
}: Props) => {
  return (
    <BootstrapDialog
      onClose={handleModalClose}
      open={isModalOpen}
      aria-labelledby="customized-dialog-title"
      aria-describedby="customized-dialog-description"
      disableEscapeKeyDown={true}
      sx={{
        padding: "2em",
      }}
    >
      <DialogBoxTitle onClose={handleModalClose}>{modalTitle}</DialogBoxTitle>
      <DialogContent id="customized-dialog-description">
        <Box sx={{ paddingTop: "0.5em" }} minWidth="250px">
          {children}
        </Box>
      </DialogContent>
    </BootstrapDialog>
  );
};

export default DialogBox;
